import "core-js/modules/es.object.get-own-property-descriptor";
import _objectSpread from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/createClass";
import _applyDecoratedDescriptor from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class;

import { lock } from '@/util/decorator';
import { request } from './util'; // 魔方链接

var baseUrl = '//activity.video.qq.com/fcgi-bin/asyn_activity';
var _window$setting$ = window.setting.魔方配置,
    reserve = _window$setting$.预约模块ID,
    actId = _window$setting$.活动ID,
    productId = _window$setting$.商品ID,
    moduleId = _window$setting$.模块ID;
var MagicService = (_class = /*#__PURE__*/function () {
  function MagicService() {
    _classCallCheck(this, MagicService);
  }

  _createClass(MagicService, null, [{
    key: "getLotteryInfo",
    value: function getLotteryInfo(params) {
      var options = _objectSpread({
        type: 21,
        option: 101,
        act_id: actId
      }, params);

      return request()(baseUrl, options);
    }
  }, {
    key: "lottery",
    value: function lottery(params) {
      var options = _objectSpread({
        type: 21,
        option: 100,
        act_id: actId
      }, params);

      return request({
        timeout: 10000
      })(baseUrl, options);
    }
  }, {
    key: "bookAct",
    value: function bookAct() {
      var options = {
        type: 30,
        option: 104,
        act_id: actId,
        module_id: reserve
      };
      return request()(baseUrl, options);
    }
  }, {
    key: "getOrderList",
    value: function getOrderList() {
      var options = {
        type: 100145,
        option: 105,
        act_id: actId,
        product_id: productId,
        module_id: moduleId
      };
      return request()(baseUrl, options);
    }
  }, {
    key: "pkgInfo",
    value: function pkgInfo() {
      var options = {
        type: 100145,
        option: 100,
        act_id: actId,
        product_id: productId,
        module_id: moduleId
      };
      return request({
        retry: 2
      })(baseUrl, options);
    }
  }, {
    key: "getShareToken",
    value: function getShareToken() {
      var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var options = _objectSpread({
        type: 100145,
        option: 103,
        act_id: actId,
        product_id: productId,
        module_id: moduleId
      }, param);

      return request()(baseUrl, options);
    }
  }, {
    key: "getMasterInfo",
    value: function getMasterInfo() {
      var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var options = _objectSpread({
        type: 100145,
        option: 106,
        act_id: actId,
        module_id: moduleId
      }, param);

      return request()(baseUrl, options);
    }
  }, {
    key: "receiveTicket",
    value: function receiveTicket() {
      var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var options = _objectSpread({
        type: 100145,
        option: 104,
        act_id: actId,
        module_id: moduleId
      }, param);

      return request()(baseUrl, options);
    }
  }, {
    key: "getReceiveInfo",
    value: function getReceiveInfo() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var options = _objectSpread({
        type: 100112,
        option: 100,
        act_id: actId
      }, params);

      return request()(baseUrl, options);
    }
  }, {
    key: "receive",
    value: function receive() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var options = _objectSpread({
        type: 100112,
        option: 101,
        act_id: actId
      }, params);

      return request()(baseUrl, options);
    }
  }]);

  return MagicService;
}(), (_applyDecoratedDescriptor(_class, "bookAct", [lock], Object.getOwnPropertyDescriptor(_class, "bookAct"), _class), _applyDecoratedDescriptor(_class, "getMasterInfo", [lock], Object.getOwnPropertyDescriptor(_class, "getMasterInfo"), _class)), _class);
export default MagicService;